var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clipboard-images"},[_c('div',_vm._l((_vm.clipboardItems),function(ref){
var text = ref.text;
var date = ref.date;
var pub = ref.pub;
var url = ref.url;
return _c('div',{style:({ 'text-align': 'left', color: 'black' })},[(url)?_c('p',[_c('a',{style:({ color: 'black', 'text-decoration': 'none' }),attrs:{"href":url}},[_vm._v(_vm._s(text))]),_c('br'),(pub)?_c('i',[_vm._v("["+_vm._s(pub)+" — "+_vm._s(date)+"]")]):_vm._e()]):_c('img',{attrs:{"src":text.replace(/^img:/, '')}})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }